/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ServiceRequestFeedback } from '../models';
/**
 * CafMemberApi - axios parameter creator
 * @export
 */
export const CafMemberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get caf member feedback by caf member id
         * @param {number} serviceRequestId 
         * @param {number} cafMemberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCafMemberFeedback: async (serviceRequestId: number, cafMemberId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceRequestId' is not null or undefined
            assertParamExists('getCafMemberFeedback', 'serviceRequestId', serviceRequestId)
            // verify required parameter 'cafMemberId' is not null or undefined
            assertParamExists('getCafMemberFeedback', 'cafMemberId', cafMemberId)
            const localVarPath = `/service-request-feedback/caf-member`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (serviceRequestId !== undefined) {
                localVarQueryParameter['serviceRequestId'] = serviceRequestId;
            }

            if (cafMemberId !== undefined) {
                localVarQueryParameter['cafMemberId'] = cafMemberId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get caf member feedback by entity partner id and (optionally) by caf member id
         * @param {number} entityPartnerId 
         * @param {number | null} [cafMemberId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCafMemberFeedbackAverageByCafMemberId: async (entityPartnerId: number, cafMemberId?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityPartnerId' is not null or undefined
            assertParamExists('getCafMemberFeedbackAverageByCafMemberId', 'entityPartnerId', entityPartnerId)
            const localVarPath = `/service-request-feedback/caf-member/average-by`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (entityPartnerId !== undefined) {
                localVarQueryParameter['entityPartnerId'] = entityPartnerId;
            }

            if (cafMemberId !== undefined) {
                localVarQueryParameter['cafMemberId'] = cafMemberId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get caf member feedback average by params
         * @param {number} entityPartnerId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {number | null} [serviceId] 
         * @param {number | null} [cafMemberId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedbackByCafMemberAverageWithParams: async (entityPartnerId: number, fromDate: string, toDate: string, serviceId?: number | null, cafMemberId?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityPartnerId' is not null or undefined
            assertParamExists('getFeedbackByCafMemberAverageWithParams', 'entityPartnerId', entityPartnerId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('getFeedbackByCafMemberAverageWithParams', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('getFeedbackByCafMemberAverageWithParams', 'toDate', toDate)
            const localVarPath = `/service-request-feedback/caf-member/average`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (entityPartnerId !== undefined) {
                localVarQueryParameter['entityPartnerId'] = entityPartnerId;
            }

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }

            if (cafMemberId !== undefined) {
                localVarQueryParameter['cafMemberId'] = cafMemberId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get caf member feedback quantity by params
         * @param {number} entityPartnerId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {number | null} [serviceId] 
         * @param {number | null} [cafMemberId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedbackByCafMemberQuantityWithParams: async (entityPartnerId: number, fromDate: string, toDate: string, serviceId?: number | null, cafMemberId?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityPartnerId' is not null or undefined
            assertParamExists('getFeedbackByCafMemberQuantityWithParams', 'entityPartnerId', entityPartnerId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('getFeedbackByCafMemberQuantityWithParams', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('getFeedbackByCafMemberQuantityWithParams', 'toDate', toDate)
            const localVarPath = `/service-request-feedback/caf-member/quantity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (entityPartnerId !== undefined) {
                localVarQueryParameter['entityPartnerId'] = entityPartnerId;
            }

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }

            if (cafMemberId !== undefined) {
                localVarQueryParameter['cafMemberId'] = cafMemberId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CafMemberApi - functional programming interface
 * @export
 */
export const CafMemberApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CafMemberApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get caf member feedback by caf member id
         * @param {number} serviceRequestId 
         * @param {number} cafMemberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCafMemberFeedback(serviceRequestId: number, cafMemberId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceRequestFeedback>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCafMemberFeedback(serviceRequestId, cafMemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CafMemberApi.getCafMemberFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get caf member feedback by entity partner id and (optionally) by caf member id
         * @param {number} entityPartnerId 
         * @param {number | null} [cafMemberId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCafMemberFeedbackAverageByCafMemberId(entityPartnerId: number, cafMemberId?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCafMemberFeedbackAverageByCafMemberId(entityPartnerId, cafMemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CafMemberApi.getCafMemberFeedbackAverageByCafMemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get caf member feedback average by params
         * @param {number} entityPartnerId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {number | null} [serviceId] 
         * @param {number | null} [cafMemberId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeedbackByCafMemberAverageWithParams(entityPartnerId: number, fromDate: string, toDate: string, serviceId?: number | null, cafMemberId?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeedbackByCafMemberAverageWithParams(entityPartnerId, fromDate, toDate, serviceId, cafMemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CafMemberApi.getFeedbackByCafMemberAverageWithParams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get caf member feedback quantity by params
         * @param {number} entityPartnerId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {number | null} [serviceId] 
         * @param {number | null} [cafMemberId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeedbackByCafMemberQuantityWithParams(entityPartnerId: number, fromDate: string, toDate: string, serviceId?: number | null, cafMemberId?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeedbackByCafMemberQuantityWithParams(entityPartnerId, fromDate, toDate, serviceId, cafMemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CafMemberApi.getFeedbackByCafMemberQuantityWithParams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CafMemberApi - factory interface
 * @export
 */
export const CafMemberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CafMemberApiFp(configuration)
    return {
        /**
         * 
         * @summary Get caf member feedback by caf member id
         * @param {number} serviceRequestId 
         * @param {number} cafMemberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCafMemberFeedback(serviceRequestId: number, cafMemberId: number, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequestFeedback> {
            return localVarFp.getCafMemberFeedback(serviceRequestId, cafMemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get caf member feedback by entity partner id and (optionally) by caf member id
         * @param {number} entityPartnerId 
         * @param {number | null} [cafMemberId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCafMemberFeedbackAverageByCafMemberId(entityPartnerId: number, cafMemberId?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getCafMemberFeedbackAverageByCafMemberId(entityPartnerId, cafMemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get caf member feedback average by params
         * @param {number} entityPartnerId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {number | null} [serviceId] 
         * @param {number | null} [cafMemberId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedbackByCafMemberAverageWithParams(entityPartnerId: number, fromDate: string, toDate: string, serviceId?: number | null, cafMemberId?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getFeedbackByCafMemberAverageWithParams(entityPartnerId, fromDate, toDate, serviceId, cafMemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get caf member feedback quantity by params
         * @param {number} entityPartnerId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {number | null} [serviceId] 
         * @param {number | null} [cafMemberId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedbackByCafMemberQuantityWithParams(entityPartnerId: number, fromDate: string, toDate: string, serviceId?: number | null, cafMemberId?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getFeedbackByCafMemberQuantityWithParams(entityPartnerId, fromDate, toDate, serviceId, cafMemberId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CafMemberApi - interface
 * @export
 * @interface CafMemberApi
 */
export interface CafMemberApiInterface {
    /**
     * 
     * @summary Get caf member feedback by caf member id
     * @param {number} serviceRequestId 
     * @param {number} cafMemberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CafMemberApiInterface
     */
    getCafMemberFeedback(serviceRequestId: number, cafMemberId: number, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequestFeedback>;

    /**
     * 
     * @summary Get caf member feedback by entity partner id and (optionally) by caf member id
     * @param {number} entityPartnerId 
     * @param {number | null} [cafMemberId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CafMemberApiInterface
     */
    getCafMemberFeedbackAverageByCafMemberId(entityPartnerId: number, cafMemberId?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<number>;

    /**
     * 
     * @summary Get caf member feedback average by params
     * @param {number} entityPartnerId 
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {number | null} [serviceId] 
     * @param {number | null} [cafMemberId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CafMemberApiInterface
     */
    getFeedbackByCafMemberAverageWithParams(entityPartnerId: number, fromDate: string, toDate: string, serviceId?: number | null, cafMemberId?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<number>;

    /**
     * 
     * @summary Get caf member feedback quantity by params
     * @param {number} entityPartnerId 
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {number | null} [serviceId] 
     * @param {number | null} [cafMemberId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CafMemberApiInterface
     */
    getFeedbackByCafMemberQuantityWithParams(entityPartnerId: number, fromDate: string, toDate: string, serviceId?: number | null, cafMemberId?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<number>;

}

/**
 * CafMemberApi - object-oriented interface
 * @export
 * @class CafMemberApi
 * @extends {BaseAPI}
 */
export class CafMemberApi extends BaseAPI implements CafMemberApiInterface {
    /**
     * 
     * @summary Get caf member feedback by caf member id
     * @param {number} serviceRequestId 
     * @param {number} cafMemberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CafMemberApi
     */
    public getCafMemberFeedback(serviceRequestId: number, cafMemberId: number, options?: RawAxiosRequestConfig) {
        return CafMemberApiFp(this.configuration).getCafMemberFeedback(serviceRequestId, cafMemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get caf member feedback by entity partner id and (optionally) by caf member id
     * @param {number} entityPartnerId 
     * @param {number | null} [cafMemberId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CafMemberApi
     */
    public getCafMemberFeedbackAverageByCafMemberId(entityPartnerId: number, cafMemberId?: number | null, options?: RawAxiosRequestConfig) {
        return CafMemberApiFp(this.configuration).getCafMemberFeedbackAverageByCafMemberId(entityPartnerId, cafMemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get caf member feedback average by params
     * @param {number} entityPartnerId 
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {number | null} [serviceId] 
     * @param {number | null} [cafMemberId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CafMemberApi
     */
    public getFeedbackByCafMemberAverageWithParams(entityPartnerId: number, fromDate: string, toDate: string, serviceId?: number | null, cafMemberId?: number | null, options?: RawAxiosRequestConfig) {
        return CafMemberApiFp(this.configuration).getFeedbackByCafMemberAverageWithParams(entityPartnerId, fromDate, toDate, serviceId, cafMemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get caf member feedback quantity by params
     * @param {number} entityPartnerId 
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {number | null} [serviceId] 
     * @param {number | null} [cafMemberId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CafMemberApi
     */
    public getFeedbackByCafMemberQuantityWithParams(entityPartnerId: number, fromDate: string, toDate: string, serviceId?: number | null, cafMemberId?: number | null, options?: RawAxiosRequestConfig) {
        return CafMemberApiFp(this.configuration).getFeedbackByCafMemberQuantityWithParams(entityPartnerId, fromDate, toDate, serviceId, cafMemberId, options).then((request) => request(this.axios, this.basePath));
    }
}

